"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = [{
  href: '/main-page/sitemap.aspx',
  target: '_self',
  text: 'Sitemap'
}, {
  href: '/company/policy/privacy.aspx',
  target: '_self',
  text: 'Privacy'
}, {
  href: '/company/policy/security.aspx',
  target: '_self',
  text: 'Security'
}, {
  href: '/company/policy/terms-of-use.aspx',
  target: '_self',
  text: 'Terms Of Use'
}, {
  href: '/company/policy/hipaa-notice.aspx',
  target: '_self',
  text: 'HIPAA'
}, {
  href: 'https://huddle.hy-vee.com/',
  target: '_self',
  text: 'Employees'
}, {
  href: 'https://www.rangeme.com/hyvee',
  target: '_self',
  text: 'Prospective Suppliers'
}, {
  href: 'https://supplierhub.hy-vee.com/',
  target: '_self',
  text: 'Suppliers'
}, {
  href: '/docs/1557-Nondiscrimination-Notice_10-17-16.pdf',
  target: '_self',
  text: 'Nondiscrimination Notice'
}];
exports.default = _default;